import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {gridDateToJson} from "@app/factory/gridDateToJson";
import {ModalSuccess} from "@app/modules/Translate/components/ModalSaveFile/ModalSuccess";
import {ModalError} from "@app/modules/Translate/components/ModalSaveFile/ModalError";
import {useStorageConfirmTranslateContext} from "@app/modules/ConfirmTranslate/contexts/storage";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface ISaveTranslateProps {
}


export const SaveTranslate: FunctionComponent<ISaveTranslateProps> = observer<FunctionComponent<ISaveTranslateProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext()
    const {languageFileModel} = useModelContext()
    const {confirmTranslateStore} = useStorageConfirmTranslateContext()

    let dataLanguageResponse = languageFileModel.dataLanguage.get()

    let disabled = !dataLanguageResponse

    const onClick = async () => {
        try {
            let saveTranslation = gridDateToJson(translateStore.gridDate)
            translateStore.changeSet.clear()
            const value = await languageFileModel.saveFileTemp(saveTranslation, translateStore.targetLanguageId || confirmTranslateStore.languageToAccept);
            translateStore.handleOpenModalSuccess();
            confirmTranslateStore.fileId = value.fileId;
        } catch (e) {
            console.error(e)
            translateStore.handleOpenModalError()
        }

    }

    return <>
        <IconButton
            disabled={disabled}
            className="featureButtons__i fa fa-save"
            aria-hidden="true"
            title="Save translation"
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faSave}/>
        </IconButton>
        <ModalSuccess/>
        <ModalError/>
    </>
});

